import { SortOrder } from 'src/app/enum/sort-order';
import { EnvelopeSortField } from 'src/app/enum/envelope-sort-field';
import { DateRangeFilter } from './date-range-filter';

export class EnvelopeFilter {
    textSearch?: string;
    skip: number;
    take: number;
    sortOrder: SortOrder;
    sortField?: EnvelopeSortField;
    creationDateRange?: DateRangeFilter;
    expirationDateRange?: DateRangeFilter;
    segmentsIds?: Array<number>;
    conclutionDateRange?: DateRangeFilter;
    creatorIds?: number;
    creatorUserName?: string;

    public EndRange(): number {
        return this.skip + this.take;
    }

    public InitRange(): number {
        return this.skip;
    }
}
